(() => {
  const init = () => {
    const nav = document.querySelector('[data-impress-navigation]');
    if (nav && !nav.dataset.ready) {
      nav.dataset.ready = 'true';
      const media = window.matchMedia('(min-width: 750px)');
      const sync = () => { nav.open = media.matches; };
      sync();
      media.addEventListener('change', sync);
      nav.querySelectorAll('.ib-department').forEach(item => {
        item.addEventListener('toggle', () => {
          if (item.open) nav.querySelectorAll('.ib-department').forEach(other => { if (other !== item) other.open = false; });
        });
      });
      document.addEventListener('click', event => {
        if (!nav.contains(event.target)) nav.querySelectorAll('.ib-department').forEach(item => { item.open = false; });
      });
      nav.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const item = event.target.closest('.ib-department[open]');
          if (item) { item.open = false; item.querySelector('summary').focus(); }
          else if (!media.matches) { nav.open = false; nav.querySelector('summary').focus(); }
        }
      });
    }
    const dialog = document.getElementById('ImpressOfferDialog');
    if (!dialog || dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
    dialog.dataset.ready = 'true';
    const key = 'impress-offer-signup-dismissed';
    const remember = () => { try { localStorage.setItem(key, String(Date.now())); } catch {} };
    const open = () => { if (!dialog.open) dialog.showModal(); };
    document.querySelectorAll('[data-impress-signup]').forEach(link => {
      link.addEventListener('click', event => { event.preventDefault(); open(); });
    });
    dialog.querySelectorAll('[data-impress-close]').forEach(button => button.addEventListener('click', () => { remember(); dialog.close(); }));
    dialog.addEventListener('cancel', remember);
    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) { remember(); dialog.close(); }
      }
    });
    if (document.querySelector('[data-impress-subscribed]')) {
      remember();
      if (location.hash.includes('ImpressPopup')) open();
      return;
    }
    let recent = false;
    try { recent = Date.now() - Number(localStorage.getItem(key) || 0) < 14 * 86400000; } catch { recent = true; }
    if (dialog.dataset.autoPopup === 'true' && !recent && !window.Shopify?.designMode) {
      const begin = () => { window.setTimeout(() => {
        const tag = document.activeElement?.tagName;
        if (!document.hidden && !['INPUT','TEXTAREA','SELECT'].includes(tag)) { open(); remember(); }
      }, 20000); };
      window.addEventListener('scroll', begin, { once: true, passive: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
